import OlFeature from 'ol/Feature';
import OlPoint from 'ol/geom/Point';
import OlStyle from 'ol/style/Style';
import OlIcon from 'ol/style/Icon';

export function createMarker(point) {
    const feature = new OlFeature({ geometry: new OlPoint(point) });
    feature.setStyle(new OlStyle({
        image: new OlIcon({
            scale: 0.75,
            size: [64, 128],
            imgSize: [64, 128], // Needed for svg rendering on IE11 & Android 4
            src: '/icons/map_point_blue_outline2.svg'
        }),
        fill: null,
        stroke: null
    }));
    return feature;
}

export function createMarkerGps() {
    const feature = new OlFeature();
    feature.setStyle(getGpsDefaultStyle());
    feature.setId('markerGps');
    return feature;
}

export function getGpsDefaultStyle() {
    return new OlStyle({
        image: new OlIcon({
            scale: 1.0,
            size: [44, 44],
            imgSize: [44, 44], // Needed for svg rendering on IE11 & Android 4
            src: require('@/assets/icons/map_location.svg')
        }),
        fill: null,
        stroke: null
    });
}

export function getGpsRoseStyle() {
    return new OlStyle({
        image: new OlIcon({
            scale: 1.0,
            size: [44, 44],
            imgSize: [44, 44], // Needed for svg rendering on IE11 & Android 4
            src: require('@/assets/icons/map_location_rose.svg')
        }),
        fill: null,
        stroke: null
    });
}

export function getGpsRoseSelectedStyle() {
    return new OlStyle({
        image: new OlIcon({
            scale: 1.0,
            size: [44, 44],
            imgSize: [44, 44], // Needed for svg rendering on IE11 & Android 4
            src: require('@/assets/icons/map_location_rose_selected.svg')
        }),
        fill: null,
        stroke: null
    });
}

export function getGpsDirectionStyle() {
    const style = new OlStyle({
        image: new OlIcon({
            scale: 1.0,
            size: [44, 44],
            imgSize: [44, 44], // Needed for svg rendering on IE11 & Android 4
            src: require('@/assets/icons/direction_north.svg')
        }),
        fill: null,
        stroke: null
    });
    return style;
}
